import { styled } from '@mui/material/styles';
import { Radio, RadioProps } from '@mui/material';
import { StyledComponent } from '@emotion/styled';
import { Colors } from '../../../constants';
import { RadioIcon, RadioCheckedIcon } from '../../../icons';

export type CoreRadioProps = Omit<RadioProps, 'checkedIcon' | 'icon'>

export const CoreRadio: StyledComponent<CoreRadioProps> = styled((props: CoreRadioProps) => (
	<Radio
		{...props}
		icon={<RadioIcon />}
		checkedIcon={<RadioCheckedIcon />}
		disableRipple={false}
	/>
))(({ theme }) => ({
	padding: 0,
	color: Colors.white,

	'& svg rect': {
		strokeOpacity: 0.3,
	},

	'&.Mui-checked': {
		color: Colors.white,
	},

	'&.Mui-disabled': {
		opacity: 0.6,
	},

	'&:hover, &.Mui-disabled': {
		color: Colors.white,
		backgroundColor: Colors.transparent,

		'& svg rect': {
			strokeOpacity: 0.8
		}
	},

	'& .MuiTouchRipple-root': {
		display: 'none',
	}
}));
